var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useMemo } from "react";
import { isSupportedIssuer } from "../lib/constants";
import useAffiliateConfig from "./useAffiliateConfig";
import useAppSelector from "./useAppSelector";
export default function useIsSupportedIssuer() {
    var _a = useAppSelector(function (state) { return state.configuration; }), trellisKey = _a.trellisKey, experience = _a.experience;
    var disabledIssuers = useAffiliateConfig().disabledIssuers;
    var disabledIssuersFromSplit = useAppSelector(function (state) { return state.configuration.disabledIssuers; });
    var allDisabledIssuers = useMemo(function () { return __spreadArray(__spreadArray([], disabledIssuers, true), disabledIssuersFromSplit, true); }, [disabledIssuers, disabledIssuersFromSplit]);
    return useCallback(function (issuer) {
        return isSupportedIssuer(issuer, trellisKey, allDisabledIssuers, experience);
    }, [trellisKey, allDisabledIssuers, experience]);
}
